<template>
  <div>
    <NewNavbar variant="signup" />
    <nuxt />
  </div>
</template>

<script>
import { unauthenticated } from '@/mixins/layouts'
import NewNavbar from '@/components/NewNavbar'

export default {
  name: 'LayoutMinimal',
  components: {
    NewNavbar
  },
  mixins: [unauthenticated]
}
</script>
